import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import SimuladorNumericInput from "./SimuladorNumericInput";
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { SimuladorIncentivosUSeminuevos } from "./SimuladorIncentivosUSeminuevos";



const SimuladorIncentivosCoordinadorMaquinariaUsada = ({ puesto }) => {
    const [formData, setFormData] = useState({
        incentivos_usados: 0,
        incentivos_unidades: 0
    });

    const [state, setState] = useState({
        unidades: 0,
        incentivo_unidades: 0
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
    };

    

    const rangoUsados = [
        { minimo: 0, maximo: 59.99, margen_bajo: 0.00250, margen_medio: 0.00450, margen_alto: 0.00550 },
        { minimo: 60, maximo: 79.99, margen_bajo: 0.00300, margen_medio: 0.00500, margen_alto: 0.00600 },
        { minimo: 80, maximo: 99.99, margen_bajo: 0.00400, margen_medio: 0.00600, margen_alto: 0.00700 },
        { minimo: 100, maximo: 119.99, margen_bajo: 0.00550, margen_medio: 0.00750, margen_alto: 0.00950 },
        { minimo: 120, maximo: 150000, margen_bajo: 0.00650, margen_medio: 0.00850, margen_alto: 0.0100 },
    ]

    const [totalSeminuevos, setTotalSeminuevos] = useState(0);

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            incentivos_usados: totalSeminuevos,
            incentivos_unidades: Number(state.unidades) * 3000,
        }));
    }, [state, totalSeminuevos, state.unidades]);

    return (
        <>
            <div className="simulador-incentivo-form-seccion">
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <AgricultureIcon /> Seminuevos
                    </div>
                    <SimuladorIncentivosUSeminuevos rango={rangoUsados} setTotal={setTotalSeminuevos} />
                </div>

                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <AutorenewIcon sx={{ fontSize: "18px" }} /> Rotación de inventario
                    </div>

                    <div className="simulador-incentivo-vendedor-f3">
                        <div className="input-section-container-numeric">
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label">Unidades vendidas con mas de 6 meses de antigüedad</div>
                                    <SimuladorNumericInput
                                        name="unidades"
                                        label=""
                                        value={state.unidades}
                                        disabled={false}
                                        onChange={handleChange}
                                        icono="numero"
                                    />
                                </div>
                            </div>
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label">Tu incentivo es de:</div>
                                    <SimuladorNumericInput
                                        name="incentivos_unidades"
                                        label=""
                                        value={formData.incentivos_unidades}
                                        disabled={true}
                                        // onChange={handleChange}
                                        icono="pesos"
                                        inputTotal="si"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulos">
                    <span>
                        Considerando los datos ingresados, tu Incentivo total simulado es:
                    </span>

                    <SimuladorNumericInput
                        // label="Nombre"
                        name="Total"
                        value={Number(formData.incentivos_unidades) + Number(formData.incentivos_usados)}
                        // onChange={handleChange}
                        align="centro"
                        size="small"
                        disabled={true}
                        sx={{ size: "12px" }}
                    />
                </div>
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
        </>
    );
};

export default SimuladorIncentivosCoordinadorMaquinariaUsada;
